import { FC, useState } from "react";
import Alert from "react-bootstrap/Alert";
import { useDebounce } from "use-debounce";
import { Company, useCompanyListQuery } from "app/api/graph/types";
import { SelectData, SelectDataProps } from "app/component/form/select/SelectData";

type Model = Pick<Company, "id" | "_id" | "name">;

export const SelectCompany: FC<SelectDataProps<Model>> = (props) => {
    const [query, setQuery] = useState<string | undefined>(undefined);
    const { data, loading, fetchMore, error } = useCompanyListQuery({
        variables: { name: useDebounce(query, 400)[0] },
        notifyOnNetworkStatusChange: true,
    });

    if (error) {
        return <Alert variant="danger">{error.message}</Alert>;
    }

    return (
        <SelectData
            {...props}
            connection={data?.companies}
            label={(value) => value.name ?? ""}
            isLoading={loading}
            onPaginate={() => fetchMore({ variables: { after: data?.companies?.pageInfo?.endCursor } })}
            onInputChange={setQuery}
        />
    );
};
